import React from "react";
import "./NewsCard.css";

const NewsCard2 = () => {
  const handleSourceClick = () => {
    window.open("https://www.myjoyonline.com/lets-take-a-look-at-regulations-of-financial-services-actuarial-society-of-ghana/", "_blank");
  };

  return (
    <div>
    <section className="section-council">
    <div className="sectiontop-line"></div>
    <h2 className="sectiontitle">LATEST NEWS</h2>
    <div className="sectionbottom-line"></div>
    </section>
    <h2 className="newstoptitle">
    Let’s take a look at regulations of financial services – Actuarial Society of Ghana
      </h2>
    <div className="newscard">
     
      <img
        src="images\News\news2.jpg" 
        alt="News"
        className="newsimage"
      />

   
      <h3 className="newstitle">
      A look at regulations of financial services
      </h3>

    
      <div className="newsmeta">
        <span className="newssource">
          Source:{" "}
          <button onClick={handleSourceClick} className="sourcelink">
          www.myjoyonline.com
          </button>
        </span>
        <span className="newsdate">Fri, 19 Nov 2021</span>
      </div>

     
      <p className="newsdescription">
        The Actuarial Society of Ghana says the tremendous change in regulations 
        surrounding the conduct of financial services business in Ghana requires the urgent look at regulatory 
        issues such as capitalization, risk management practices, Asset-Liability Management (ALM) strategies, 
        governance and more crucially and recently International Financial Reporting Standards.
        <br />
        <br />
        Though it agrees with the various regulators - the National Insurance Commission, 
        the National Pension’s Regulatory Authority, the Bank of Ghana and the Security and 
        Exchange Commission that the consolidated impact of these efforts and major changes is 
        to ensure a sound and financially stable economy, it said a more critical growing concern 
        is the availability of highly skilled economic work force to facilitate and guide these regulatory transitions.
        <br />
        <br />
        Speaking at the Actuaries Society of Ghana Actuaries Connect Conference 2021, 
        President of the Actuarial Society of Ghana, Neil Tagoe, said there is the need to take a second look at upcoming
        issues that substantially impact on the economic well being of the people.
        <br />
        <br />
        “Not to duel on the financial service sector only, as that forms only a part of our national economic life,
        there is still a myriad of upcoming issues that continues to substantially impact and play a significant
         part in the day-to-day lives of the ordinary Ghanaian that require more than the traditional skill of today’s risk professional”.
         <br />
         <br />
        To consider a few, these major national issues, Mr. Tagoe said includes the ongoing national 
        digitisation regime spearheaded by the Vice President, Dr. Mahamudu Bawumia, disaster and crises 
        management and its associated risk, climate change and climate risk, amongst others.
        <br />
        <br />
        He therefore called for a strategic focus in mobilising enough resources to build the technical and 
        professional competence that is required to fulfil these mandates in the future, adding “this, 
        if successful and coupled with our core skills-set will position the profession as pillar of the future Ghana we envisage.”
        <br />
        <br />
        He expressed worry that the challenges mentioned at the last conference has been carried over with 
        deepening effects further to the spread of the new variants of the Covid-19 virus which happens to 
        have stalled or slowed down general economic activities. 
        <br />
        <br />
        A recap of both new and existing challenges that still lingers in shadows over the period, 
        he said includes membership commitment to Society’s course, poor publicity of the profession, 
        financial resources for the management of the Actuaries Society of Ghana Secretariat, 
        still-growth in the non-life practice and retention of student member candidates in industry.
        <br />
        <br />
        Though the preceding year through the first half of this year have been characterised by no 
        significant activities for the general membership, the President of ASG stressed that the committee 
        meetings have been consistent in trying to proffer solutions to the challenges we are 
        confronted with as a professional organization.
        <br />
        <br />
        “Our Committees and the ASG Secretariat’s activities may not be visible to all, 
        but the resultant effect of their efforts to curtail the challenges are evident with 
        lasting future impacts soon to hit the entire actuarial community and the industries where members work.”
        <br />
        <br />
        He expressed some of the success chalked as a strategic plan to implement a full-scale non-Life 
        actuarial office role by the Non-Life Committee and the development of an ASG Education Pathway by the Education Committee.
        <br />
        <br />
        Meanwhile, ASG has invited all industry and non-industry players to the 
        6th African Actuarial Conference in March next year which Ghana would be hosting.
      </p>
    </div>
    </div>
  );
};

export default NewsCard2;
